import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Menu from "../pages/menu/page";
import Gallery from "../pages/gallery/page";
import Events from "../pages/events/page";
import AccessibilityStatement from "../pages/accessibility/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/menu", element: <Menu /> },
  { path: "/gallery", element: <Gallery /> },
  { path: "/events", element: <Events /> },
  { path: "/accessibility", element: <AccessibilityStatement /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
